"use strict";

define(['app', './base'], function (app, Helper) {
  return Helper.extend({
    ui: {
      link: '.js-ajax-link'
    },
    options: {
      onSuccessRedirect: true,
      callBack: false
    },
    events: {
      'click @ui.link': 'ajaxLink'
    },
    ajaxLink: function ajaxLink(e) {
      if (e.target.classList.contains('js-phrase')) {
        return;
      }

      e.preventDefault();
      this.loadContent(app.$(e.currentTarget));
      e.stopPropagation();
    },
    loadContent: function loadContent($el) {
      var self = this;
      var url = $el.attr('href');
      var dataparam = $el.data('params') || this.options.params;
      var onceDone = $el.data('command-done') || null;
      var action = $el.data('action') || null;

      if (!this.isLoading) {
        this.isLoading = true;
        $el.addClass('is-loading');
        app.$.ajax({
          method: action,
          url: url,
          data: dataparam
        }).done(function (data) {
          self.isLoading = false;
          $el.removeClass('is-loading');
          if (onceDone) app.events.commands.execute(onceDone);

          if (app._.isFunction(self.options.callBack)) {
            self.options.callBack.call(self, data, dataparam);
          }
        });
      }
    }
  });
});